<!-- https://www.figma.com/design/K7vDg6el3Bz7MHUdlMREDj/Credit-Conversion-Statuses?node-id=2027-58&p=f&m=dev -->
<template>
  <CardLayout
    button-href="/dashboard"
    button-text="Go to dashboard"
    title="All set! This has already been processed."
    :body="cardBody"
    :button-data-layer-event="dataLayerEvent"
    :button-disabled="false"
  >
    <template #art>
      <ArtAlreadyProcessed />
    </template>
  </CardLayout>
</template>

<script>
import CardLayout from '../ui/CardLayout.vue';
import ArtAlreadyProcessed from './ArtAlreadyProcessed.vue';

export default {
  name: 'CardAlreadyProcessed',
  components: {
    CardLayout,
    ArtAlreadyProcessed
  },
  data() {
    return {
      /**
       * @type {import('../ui/card-body').CardBody}
       */
      cardBody: {
        blocks: [
          {
            lines: [
              `Your credit request has already been processed and added to your transcript. You can view your progress and all completed courses on your dashboard.`
            ]
          }
        ]
      }
    };
  },
  computed: {
    dataLayerEvent() {
      return {
        event: 'link',
        action: 'click',
        name: 'onclick',
        type: 'internal link',
        region: 'main content',
        section: 'all set! this has already been processed',
        text: 'go to dashboard',
        component: 'already processed card'
      };
    }
  }
};
</script>
